"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingReset = void 0;
var _styledComponents = require("styled-components");
var spacingReset = exports.spacingReset = (0, _styledComponents.css)(["margin:0;padding:0;padding-inline-start:0;padding-inline-end:0;"]);